import { render, staticRenderFns } from "./CentralKlaus.vue?vue&type=template&id=bc6b747c&"
import script from "./CentralKlaus.vue?vue&type=script&lang=js&"
export * from "./CentralKlaus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports